import {Box, Typography} from '@mui/material';
import Banner from './Banner';
import BrowseAllCategories from './BrowseAllCategories';
import FeaturedCourses from './FeaturedCourses';
import TopInstitutes from './TopInstitutes';
import {Image} from '@jobseeker/lotus/components/Image';
import TrendingCourses from './TrendingCourses';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';

const HiristLearningHomepage = () => {
  const isDeviceLarge = useIsLargeDevice();

  return (
    <Box bgcolor="white">
      <Banner />
      <FeaturedCourses />
      <BrowseAllCategories />
      <TopInstitutes />

      <Box mt={15} maxWidth={1370} ml="auto" mr="auto">
        <Typography
          fontSize={20}
          fontWeight={600}
          sx={{
            textDecoration: 'underline #f59f4b',
          }}
          textAlign="center"
        >
          CONNECT WITH THE RIGHT COURSE AND ACCELERATE YOUR CAREER
        </Typography>
        <Box
          display="flex"
          justifyContent="space-around"
          textAlign="center"
          flexDirection={isDeviceLarge ? 'row' : 'column'}
        >
          <Box
            display="grid"
            justifyItems="center"
            maxWidth={340}
            ml="auto"
            mr="auto"
            mt={5}
          >
            <Box
              bgcolor="rgb(243, 251, 251)"
              borderRadius="50%"
              width={100}
              height={100}
              p={1.5}
              pt={2}
            >
              <Image
                src="https://static.hirist.com/learning/static/images/certification.png"
                alt="Learn from experts"
                height={75}
                width={75}
              />
            </Box>
            <Typography mt={5} fontSize={20}>
              Learn from the experts
            </Typography>
            <Typography mt={2} color="rgba(113, 113, 113, 0.9)">
              Get certified from the best of institutes across the globe.
            </Typography>
          </Box>
          <Box
            display="grid"
            justifyItems="center"
            maxWidth={340}
            ml="auto"
            mr="auto"
            mt={5}
          >
            <Box
              bgcolor="rgb(243, 251, 251)"
              borderRadius="50%"
              width={100}
              height={100}
              p={1.5}
              pt={2}
            >
              <Image
                src="https://static.hirist.com/learning/static/images/Personalizedcourseadvise.png"
                alt="Personalized course advice"
                height={75}
                width={75}
              />
            </Box>
            <Typography mt={5} fontSize={20}>
              Personalized course advice
            </Typography>
            <Typography mt={2} color="rgba(113, 113, 113, 0.9)">
              Get personalized course advice and pick the perfect course for
              your career aspirations.
            </Typography>
          </Box>
          <Box
            display="grid"
            justifyItems="center"
            maxWidth={340}
            ml="auto"
            mr="auto"
            mt={5}
          >
            <Box
              bgcolor="rgb(243, 251, 251)"
              borderRadius="50%"
              width={100}
              height={100}
              p={1.5}
              pt={2}
            >
              <Image
                src="https://static.hirist.com/learning/static/images/opportunities.png"
                alt="Accelerated career growth"
                height={75}
                width={75}
              />
            </Box>
            <Typography mt={5} fontSize={20}>
              Accelerated career growth
            </Typography>
            <Typography mt={2} color="rgba(113, 113, 113, 0.9)">
              Choose from thousands of opportunities to take your career to next
              level.
            </Typography>
          </Box>
        </Box>
      </Box>

      <TrendingCourses />
    </Box>
  );
};

export default HiristLearningHomepage;
